import cn from 'classnames/bind';
import PropTypes from 'prop-types';

import s from './WithAspect.module.scss';

const cx = cn.bind(s);

const WithAspect = ({
  children, aspect = 1, className, ...attrs
}) => {
  const styles = {};
  if (typeof aspect === 'number') {
    styles['--aspect'] = `${aspect * 100}%`;
  } else if (typeof aspect === 'object') {
    Object.entries(aspect).forEach(([size, value]) => {
      styles[`--aspect-${size}`] = `${value * 100}%`;
    });
  }
  return (
    <div className={cx(className)} {...attrs}>
      <div className={cx('aspect')} style={styles}>
        <div className={cx('aspect-content')}>
          {children}
        </div>
      </div>
    </div>
  );
};

WithAspect.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default WithAspect;
